export const ACCEPTED_AI_FILE_TYPES = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

// FileAttachment.data accepts at most 10,000,000 base64 characters. Base64
// expands raw bytes by 4/3, so this is the largest file that always fits.
export const MAX_ASK_DECODA_FILE_SIZE = 7_500_000;
export const MAX_AI_CHAT_FILE_COUNT = 10;
// Keeps the base64 request payload below the API's 25,000,000-character cap.
export const MAX_AI_CHAT_TOTAL_FILE_SIZE = 18_750_000;

export const ACCEPTED_ASK_DECODA_FILE_TYPES = [
  ...ACCEPTED_AI_FILE_TYPES,
  ".csv",
  ".xlsx",
  "text/csv",
  "application/csv",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
